import createStyleSheet from "If_AdTool/common/createStyleSheet";
/***
 * 文章内页文字链
 * 在 articleBottomAdAuto 和当前div选一个位置放
 * 04 25修改为可以在两个位置都上
 * ***/
function mutiElTxt(el,data) {
    let elArr=[el];
    let id = "g" + window.IfengAmgr.uuid();
    let cnt = `.a_txt{
            color: #404040;
            line-height:30px;
            font-size: 16px;
            font-weight: 400;
            margin-top: 20px;
            width:640px;
        }
        .a_txt a{
            color:#212223;
        }
        .a_txt a:hover{ 
            cursor: pointer;
            color:#ff3040;
        }`;
    cnt = cnt.replace(/a_txt/g, id);
    createStyleSheet(cnt);
    let otherEl = document.getElementById("articleBottomAdAuto");
    if (otherEl){
        elArr.push(otherEl);
    }
    let { pos=0, aids} =data;
    if (aids.length==1){
        pos = parseInt(pos);
        let adEl = elArr[0];
        if (elArr[pos]) {
            adEl = elArr[pos];
        }
        adEl.className = id;
        if (adEl == el) {
            adEl.style.marginTop = "10px";
            adEl.style.marginBottom = "-40px";
        }
        window.IfengAmgr.show(adEl, { aids: aids })
    } else if (aids.length == 2) {
       // debugger;
        let posArr = pos.split(",");
        let elObj = {};
        el.style.marginTop = "10px";
        el.style.marginBottom = "-20px";
        for (let i=0;i<aids.length;i++){
            let { ap } = aids[i];
            let adEl = elArr[posArr[i]];
            adEl.className = id;
            adEl.setAttribute(window.IfengAmgr.pex, ap);
            elObj[ap] = adEl;
        }
        window.IfengAmgr.show(elObj, { aids: aids })
    }
    
};
{/* <!--!{
    data: {
        "aids": [
            { "ap": "41662", "w": "640", "h": "30", "res": "1" }
        ],
            "pos": 1,
    },
    preload: 'https://x0.ifengimg.com/feprod/c/web/d/mutiElTxt.js',
        callback: 'function(elm, data) {window.IfengAmgr.tplLib.mutiElTxt.render(elm,data);}'
} !--> */}
if (typeof window.IfengAmgr != undefined) {
    window.IfengAmgr.tplLib.mutiElTxt = { render: mutiElTxt, version: "1.0.0" };
}